import axios, { type AxiosRequestConfig, type Canceler } from 'axios'
import * as httpSettings from '@/config/httpSettings'
import store from '@/store'
import { logOutAction } from '@/store/slices/common'
// import { message } from 'antd'
import HyStore from './storage'
import qs from 'qs'
import { message } from 'antd'

const hyLocalStore = new HyStore(httpSettings.tokenStoragePosition)

const CancelToken = axios.CancelToken

type IHeaders = AxiosRequestConfig['headers']
export interface DataType<T> {
  headers: any
  code: number
  message: string
  data: T | null
}

const formatHeaders = (acHeaders: IHeaders): IHeaders => {
  const headers: IHeaders = {}

  headers.Token = hyLocalStore.getItem(httpSettings.tokenStorageKey) ?? ''
  headers['content-type'] = httpSettings.contentType

  return Object.assign(headers, acHeaders)
}

class Http {
  private readonly axiosInstance = axios.create()
  private pending: Array<{ url: string; c: Canceler }> = []

  constructor() {
    this.axiosInstance.interceptors.response.use(
      (res) => {
        const response = res.data
        if (response.code) {
          const code = response.code.toString()
          // 非0状态码则代码响应有问题
          if (code !== '200' && code !== '0') {
            if (res.config.url !== '/crossbowSystem/getDialogTag') {
              if (code === '405') {
                void message.warning(response.message || '网络错误，请稍后再试')
              } else {
                void message.error(response.message || '网络错误，请稍后再试')
              }
            }
            switch (code) {
              case httpSettings.tokenInvalidCode:
                store.dispatch(logOutAction())
                break
            }
            return Promise.reject(response)
          }
          return response
        } else {
          return response
        }
      },
      async (err) => {
        return await Promise.reject(err)
      }
    )

    this.axiosInstance.interceptors.request.use((config) => {
      const { url, headers, data, method } = config
      const accHeaders = formatHeaders(headers)
      let fixedUrl = `/${url ?? ''}`?.replace(/\/+/g, '/')
      fixedUrl = process.env.NODE_ENV === 'development' ? `/rpc${fixedUrl}` : fixedUrl
      Object.assign(
        config,
        {
          url: fixedUrl,
          timeout: httpSettings.timeout,
          headers: accHeaders,
          cancelToken: new CancelToken((c) => {
            this.pending.push({ url: url as string, c })
          })
        },
        method?.toUpperCase() === 'POST' &&
          accHeaders?.['content-type'] === 'application/x-www-form-urlencoded' &&
          data !== undefined
          ? { data: qs.stringify(data) }
          : null
      )
      // console.log('=====config1', config)
      return config
    })
  }

  public async request<T = any, D = any>(config: AxiosRequestConfig<D>) {
    const { url, method, data } = config
    // console.log('=====config', config)
    if (url === undefined || url === '') throw new Error('请传入url')
    if (method === undefined || method === '') throw new Error('请传入method')
    if (method.toUpperCase() === 'POST' && data === undefined) throw new Error('请传入data')

    try {
      const res = await this.axiosInstance.request<T, DataType<T>>(config)
      this.finish(url)
      return res
    } catch (err) {
      if (!axios.isCancel(err)) this.finish(url)
      throw err
    }
  }

  private finish(url: string): void {
    this.pending = this.pending.filter((item) => item.url !== url)
  }

  public cancel(url: string): void {
    for (let i = 0; i < this.pending.length; i++) {
      if (this.pending[i].url === url) {
        this.pending[i].c()
        this.pending.splice(i, 1)
        break
      }
    }
  }

  public cancelAllRequest(): void {
    this.pending.forEach((item) => {
      item.c()
    })
    this.pending = []
  }
}

export default Http
